import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins, faGem, faGamepad, faUsers } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/logo.png';
import pfp from '../../assets/pfp.jpeg';
import coin1 from '../../assets/image/coin (1).png';
import coin2 from '../../assets/image/coin (2).png';
import playBtn from '../../assets/image/button.png';

const MainContainer = styled.div`
  grid-area: 3 / 2 / 7 / 5;
  padding: 20px;
  overflow: hidden;
`;

const StatsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
`;

const StatBox = styled.div`
  flex: 1;
  background-color: var(--stats-bg);
  border: 1px solid #2d354d;
  border-radius: 4px;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

const StatContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const StatIcon = styled.div`
  font-size: 24px;
  margin-right: 12px;
  color: var(--yellow);
`;

const StatValue = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: var(--text-white);
`;

const StatLabel = styled.div`
  font-size: 12px;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-left: 36px;
`;

const ActionBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  img[alt="play-btn"] {
    border: 2px solid var(--yellow);
    border-radius: 6px;
    transition: box-shadow 0.2s, border-color 0.2s;
    cursor: pointer;

    &:hover {
      box-shadow: 0 0 0 2px var(--yellow), 0 2px 12px rgba(255,184,0,0.3);
      border-color: #ffd84a;
    }
  }
`;

const PreviousGames = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  padding: 10px 0;
`;

const PreviousGamesLabel = styled.span`
  font-size: 15px;
  font-weight: 600;
  margin-right: 15px;
`;

const GameStats = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: auto;
`;

const GameStat = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  font-weight: 700;

  span {
    color: var(--text-white);
  }
`;

const BettingHistory = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`;

const BetBox = styled.div.withConfig({ shouldForwardProp: (prop) => prop !== 'noBg' })<{ noBg?: boolean }>`
  display: flex;
  align-items: center;
  padding: 20px;
  margin-bottom: 15px;
  background-color: ${props => props.noBg ? 'transparent' : 'rgba(30, 34, 51, 0.5)'};
  border-radius: 6px;
  transition: box-shadow 0.2s, border 0.2s, background 0.2s;
  box-shadow: none;
  border: none;
  &:hover {
    box-shadow: 0 0 0 2px var(--yellow), 0 2px 12px rgba(255,184,0,0.08);
    background: rgba(255, 184, 0, 0.04);
  }
`;

const BetProfiles = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ProfilePic = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
`;

const VsText = styled.span`
  font-weight: 700;
`;

const BetAmount = styled.div`
  font-weight: 600;
  color: var(--text-white);
  margin-left: 80px;
`;

const BetAction = styled.div`
  font-weight: 700;
  color: var(--yellow);
  margin-right: 40px;
  margin-left: 80px;
`;

const ViewOutcome = styled.button`
  margin-left: auto;
  background: transparent;
  border: 1px solid var(--border-light);
  color: var(--text-light);
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: var(--yellow);
    border-color: var(--yellow);
    color: var(--sidebar-bg);
    box-shadow: 0 2px 8px rgba(255,184,0,0.15);
    transform: translateY(-2px) scale(1.04);
  }
`;

const CoinImage = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-left: 80px;
`;

const CreateGameButton = styled.button`
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    120deg,
    #FFC73A,
    #FFC73A 18px,
    #FFE07A 18px,
    #FFE07A 36px
  );
  color: var(--sidebar-bg);
  font-weight: 900;
  font-size: 22px;
  text-transform: uppercase;
  border: none;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(255,184,0,0.08);
  letter-spacing: 1px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  outline: none;
  &:hover {
    background: repeating-linear-gradient(
      120deg,
      #FFE07A,
      #FFE07A 18px,
      #FFC73A 18px,
      #FFC73A 36px
    );
    color: #222;
    box-shadow: 0 0 0 2px #FFE07A, 0 2px 8px rgba(255,184,0,0.2);
  }
`;

const MainContent = () => {
  return (
    <MainContainer>
      <StatsContainer>
        <StatBox>
          <StatContent>
            <StatIcon><FontAwesomeIcon icon={faCoins} /></StatIcon>
            <StatValue>5,236,302</StatValue>
          </StatContent>
          <StatLabel>Total Amount</StatLabel>
        </StatBox>

        <StatBox>
          <StatContent>
            <StatIcon><FontAwesomeIcon icon={faGem} /></StatIcon>
            <StatValue>948</StatValue>
          </StatContent>
          <StatLabel>Total Gems</StatLabel>
        </StatBox>

        <StatBox>
          <StatContent>
            <StatIcon><FontAwesomeIcon icon={faGamepad} /></StatIcon>
            <StatValue>0</StatValue>
          </StatContent>
          <StatLabel>Available Games</StatLabel>
        </StatBox>

        <StatBox>
          <StatContent>
            <StatIcon><FontAwesomeIcon icon={faUsers} /></StatIcon>
            <StatValue>100</StatValue>
          </StatContent>
          <StatLabel>Total Players</StatLabel>
        </StatBox>

        <StatBox as={ActionBox}>
          <CreateGameButton>CREATE A GAME</CreateGameButton>
        </StatBox>
      </StatsContainer>

      <PreviousGames>
        <PreviousGamesLabel>Previous games:</PreviousGamesLabel>
        <CoinImage src={coin1} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin1} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin1} alt="coin-orange" />
        <CoinImage src={coin1} alt="coin-orange" />
        <CoinImage src={coin1} alt="coin-orange" />
        <CoinImage src={coin1} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin2} alt="coin-orange" />
        <CoinImage src={coin1} alt="coin-orange" />

        <GameStats>
          <GameStat>
            <CoinImage src={coin2} alt="coin-orange" />
            <span>43%</span>
          </GameStat>
          <GameStat>
            <CoinImage src={coin1} alt="coin-orange" />
            <span>57%</span>
          </GameStat>
        </GameStats>
      </PreviousGames>

      <BettingHistory>
        <BetBox>
          <BetProfiles>
            <ProfilePic src={pfp} />
            <VsText>VS</VsText>
            <ProfilePic src={logo} />
          </BetProfiles>
          <BetAmount>$ 745.91</BetAmount>
          <BetAction>DOUBLE DOWN</BetAction>
          <CoinImage src={coin2} alt="coin-orange" />
          <ViewOutcome>VIEW OUTCOME</ViewOutcome>
        </BetBox>

        <BetBox noBg>
          <BetProfiles>
            <ProfilePic src={pfp} />
            <VsText>VS</VsText>
            <ProfilePic src={logo} />
          </BetProfiles>
          <BetAmount>$ 471.59</BetAmount>
          <BetAction>DOUBLE DOWN</BetAction>
          <CoinImage src={coin1} alt="coin-orange" />
          <ViewOutcome>VIEW OUTCOME</ViewOutcome>
        </BetBox>

        <BetBox>
          <BetProfiles>
            <ProfilePic src={pfp} />
            <VsText>VS</VsText>
            <ProfilePic src={logo} />
          </BetProfiles>
          <BetAmount>$ 376.32</BetAmount>
          <BetAction>DOUBLE DOWN</BetAction>
          <CoinImage src={coin2} alt="coin-orange" />
          <ViewOutcome>VIEW OUTCOME</ViewOutcome>
        </BetBox>

        <BetBox noBg>
          <BetProfiles>
            <ProfilePic src={pfp} />
            <VsText>VS</VsText>
            <ProfilePic src={logo} />
          </BetProfiles>
          <BetAmount>$ 318.28</BetAmount>
          <BetAction>DOUBLE DOWN</BetAction>
          <CoinImage src={coin1} alt="coin-orange" />
          <ViewOutcome>VIEW OUTCOME</ViewOutcome>
        </BetBox>

        <BetBox>
          <BetProfiles>
            <ProfilePic src={pfp} />
            <VsText>VS</VsText>
            <ProfilePic src={logo} />
          </BetProfiles>
          <BetAmount>$ 272.26</BetAmount>
          <BetAction>DOUBLE DOWN</BetAction>
          <CoinImage src={coin2} alt="coin-orange" />
          <ViewOutcome>VIEW OUTCOME</ViewOutcome>
        </BetBox>

        <BetBox noBg>
          <BetProfiles>
            <ProfilePic src={pfp} />
            <VsText>VS</VsText>
            <ProfilePic src={logo} />
          </BetProfiles>
          <BetAmount>$ 239.55</BetAmount>
          <BetAction>DOUBLE DOWN</BetAction>
          <CoinImage src={coin1} alt="coin-orange" />
          <ViewOutcome>VIEW OUTCOME</ViewOutcome>
        </BetBox>
      </BettingHistory>
    </MainContainer>
  );
};

export default MainContent; 